module.exports = __webpack_public_path__ + "media/images/google-logo-c3a80c74d6f70972e8fddae70083fe25.svg";